import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FormActionListApiModel } from '@app/api/api-models/dashboard/FormActionListApiModel';
import { ReportsOverviewApiModel } from '@app/api/api-models/dashboard/ReportsOverviewApiModel';
import { ProgramRoleApiModel } from '@app/api/api-models/dashboard/ProgramRoleApiModel';
import { DashboardAlertApiModel } from '@app/api/api-models/dashboard/DashboardAlertApiModel';
import { DashboardSearchResultApiModel } from '@app/api/api-models/dashboard/DashboardSearchResultApiModel';
import { DashboardHeaderApiModel } from '@app/api/api-models/dashboard/DashboardHeaderApiModel';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class PeDashboardService {
  public apiUrl = 'pe-dashboard';
  public apiSearchUrl = 'search';

  constructor(private readonly http: HttpClientService) {}

  public getHeaderInfo(programRoleId: string): Observable<DashboardHeaderApiModel> {
    return this.http.get<DashboardHeaderApiModel>(`${this.apiUrl}/${programRoleId}/header-info`);
  }

  public getAvailableForms(programRoleId: string): Observable<Array<FormActionListApiModel>> {
    return this.http.get<Array<FormActionListApiModel>>(`${this.apiUrl}/${programRoleId}/available-forms`);
  }

  public getInstances(programRoleId: string): Observable<Array<DashboardSearchResultApiModel>> {
    return this.http.get<Array<DashboardSearchResultApiModel>>(
      `${this.apiSearchUrl}/${programRoleId}/trainee-form-instances`
    );
  }

  public getReportsOverview(programRoleId: string): Observable<ReportsOverviewApiModel> {
    return this.http.get<ReportsOverviewApiModel>(`${this.apiUrl}/${programRoleId}/reports-overview`);
  }

  public getRelatedSubjects(formId: number): Observable<Array<ProgramRoleApiModel>> {
    return this.http.get<Array<ProgramRoleApiModel>>(`${this.apiUrl}/related-subjects`, {
      params: {
        formId: formId.toString()
      }
    });
  }

  public getAlerts(programRoleId: string): Observable<Array<DashboardAlertApiModel>> {
    return this.http.get<Array<DashboardAlertApiModel>>(`${this.apiUrl}/${programRoleId}/alerts`);
  }
}
